import { useLazyQuery } from '@apollo/client';
import {
  DownloadRevenueReportCsvDocument,
  RevenueReportType,
} from '@website/types/graphqlOperations';
import { useCallback } from 'react';
import { Button } from 'react-bootstrap';

type Props = {
  type: RevenueReportType;
};

export default function DownloadRevenueReportCSVButton({ type }: Props) {
  const [download, { loading }] = useLazyQuery(
    DownloadRevenueReportCsvDocument,
  );

  const handleDownload = useCallback(async () => {
    const { data } = await download({
      variables: {
        input: { type },
      },
    });
    const { downloadUrl } = data.downloadRevenueReport;
    // Create a link and click it to download the file
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'reviews.csv';
    document.body.appendChild(link);
    link.click();
  }, [download, type]);

  return (
    <Button variant="primary" onClick={handleDownload} disabled={loading}>
      Download CSV
    </Button>
  );
}
